import { contact } from "../../models/site";
import { PageIntro } from "./PageIntro";

export function PrivacyPage() {
  return (
    <div className="standard-page privacy-page">
      <PageIntro
        eyebrow="PRIVACY NOTICE"
        title="個人資料蒐集告知"
        en="YOUR INFORMATION, KEPT SIMPLE"
      >
        <p>
          為了完成住宿服務、處理回饋或聯繫申請，我們會依本頁說明使用你提供的資料。
        </p>
      </PageIntro>

      <section className="privacy-content" aria-label="個人資料蒐集與使用說明">
        <article>
          <h2>蒐集者與使用目的</h2>
          <p>
            蒐集者為都蘭小星民宿。我們會依你使用的表單，將資料用於訂房與入住管理、匯款核對、旅客服務與聯繫、回饋分析與服務改善，或職缺／打工換宿的評估與聯繫。旅客聯絡資料也可能用於顧客關係維護，以及提供住宿相關資訊或優惠。
          </p>
        </article>

        <article>
          <h2>會蒐集哪些資料</h2>
          <ul>
            <li>身分與聯絡資料，例如姓名、生日、現居地、Email、電話及你選擇提供的社群帳號。</li>
            <li>訂房、入住與匯款資料，例如住宿日期、房型、晚數、抵達時間、匯款金額及帳號末五碼。</li>
            <li>回饋或申請內容，例如評分、文字回饋、經歷、自我介紹、可配合日期及申請回答。</li>
            <li>使用網站時產生的必要連線與安全紀錄。</li>
          </ul>
          <p>
            住宿回饋不要求填寫姓名或 Email；由訂單專屬連結進入時，可能連同已驗證的訂單資料供內部辨識。
          </p>
        </article>

        <article>
          <h2>利用期間、地區、對象與方式</h2>
          <p>
            資料會以電子或其他適當方式，在臺灣及受託服務提供者實際提供服務的地區，由小星、完成上述目的所需的受託服務提供者，或依法有權的機關處理及利用。
          </p>
          <p>
            入住與匯款資料原則上最長保存五年；住宿回饋及未錄取或未繼續進行的申請，原則上最長保存一年。依法令、契約履行或爭議處理需要較長期間時，保存至必要期間屆滿；錄取後的資料則依聘僱或合作關係管理。
          </p>
        </article>

        <article>
          <h2>你的選擇與權利</h2>
          <p>
            你可以選擇不提供非必填資料；若不提供表單標示的必填資料，我們可能無法完成入住安排、聯繫或申請評估。住宿回饋不要求姓名或 Email；未由訂單專屬連結進入時，可不帶訂單資料提交。
          </p>
          <p>
            如需查詢、閱覽、取得複本、補充、更正、停止蒐集／使用或刪除資料，請寄信至
            <a href={`mailto:${contact.email}`}>{contact.email}</a>。如不希望收到住宿資訊或優惠，也可透過同一方式告知我們停止寄送。為保護資料，我們可能先確認身分或資料關聯。
          </p>
        </article>
      </section>
    </div>
  );
}
